import { metrics } from '@atlassian/browser-metrics';

import {
	type PageSegmentLoadPerformanceEventConfig,
	BMEventsType,
} from '@atlassian/browser-metrics/types';

export type LoadingMetricContentType = 'editPage' | 'viewPage';

export const embeddedViewToEditTransitionMetric = () =>
	metrics.interaction({
		key: 'embedded-confluence-view-to-edit-transition',
	});

const timings = [
	{ key: 'lazy-load', startMark: 'lazy-load-start', endMark: 'lazy-load-end' },
	{ key: 'common-load', startMark: 'common-load-start', endMark: 'common-load-end' },
	{
		key: 'iframe-content-initialized',
		startMark: 'iframe-content-initialized-start',
		endMark: 'iframe-content-initialized-end',
	},
];

const loadingMetricsConfig: Record<
	LoadingMetricContentType,
	PageSegmentLoadPerformanceEventConfig
> = {
	viewPage: {
		key: 'embedded-confluence-view-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
	editPage: {
		key: 'embedded-confluence-edit-page-iframe',
		type: BMEventsType.PAGE_SEGMENT_LOAD,
		timings,
	},
};

export const embeddedConfluenceIframeLoadMetrics = (contentType: LoadingMetricContentType) =>
	metrics.pageSegmentLoad(loadingMetricsConfig[contentType]);
